export const modalKeys = {
  connectWallet: 'connect-wallet',
  connectedWalletsMobile: 'connected-wallets-mobile',
} as const
